export default __webpack_public_path__ + "static/media/background.4582fa2d.jpg";